// DO NOT EDIT -- generated from fs/services/search-settings/datalayer.proto

import { ComputedPropertyWithHistory } from './computedproperties.proto';
import * as protobuf from '../../../google/protobuf';

export namespace DataLayerPublic {

  export const GetDataLayerEndpoint = "/grpc/search_settings.DataLayerPublic/GetDataLayer";
  export function GetDataLayer(sender: (req: GetDataLayerRequest, endpoint: string) => Promise<GetDataLayerResponse>, req: GetDataLayerRequest): { promise: () => Promise<GetDataLayerResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDataLayerEndpoint),
      endpoint: GetDataLayerEndpoint
    };
  }

  export const SetDataLayerEndpoint = "/grpc/search_settings.DataLayerPublic/SetDataLayer";
  export function SetDataLayer(sender: (req: SetDataLayerRequest, endpoint: string) => Promise<SetDataLayerResponse>, req: SetDataLayerRequest): { promise: () => Promise<SetDataLayerResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetDataLayerEndpoint),
      endpoint: SetDataLayerEndpoint
    };
  }

  export const DeleteDataLayerEndpoint = "/grpc/search_settings.DataLayerPublic/DeleteDataLayer";
  export function DeleteDataLayer(sender: (req: DeleteDataLayerRequest, endpoint: string) => Promise<{}>, req: DeleteDataLayerRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteDataLayerEndpoint),
      endpoint: DeleteDataLayerEndpoint
    };
  }

  export const PublishDataLayerEndpoint = "/grpc/search_settings.DataLayerPublic/PublishDataLayer";
  export function PublishDataLayer(sender: (req: PublishDataLayerRequest, endpoint: string) => Promise<PublishDataLayerResponse>, req: PublishDataLayerRequest): { promise: () => Promise<PublishDataLayerResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PublishDataLayerEndpoint),
      endpoint: PublishDataLayerEndpoint
    };
  }

  export const GetPublishedDataLayerEndpoint = "/grpc/search_settings.DataLayerPublic/GetPublishedDataLayer";
  export function GetPublishedDataLayer(sender: (req: GetPublishedDataLayerRequest, endpoint: string) => Promise<GetPublishedDataLayerResponse>, req: GetPublishedDataLayerRequest): { promise: () => Promise<GetPublishedDataLayerResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPublishedDataLayerEndpoint),
      endpoint: GetPublishedDataLayerEndpoint
    };
  }
}

export interface GetDataLayerRequest {
  orgId: string;
  id: string;
}

export interface GetDataLayerResponse {
  dataLayer: DataLayer | null;
}

export interface SetDataLayerRequest {
  orgId: string;
  id: string;
  computedPropertyHistoryIds: number[];
}

export interface SetDataLayerResponse {
  dataLayer: DataLayer | null;
}

export interface DeleteDataLayerRequest {
  orgId: string;
  id: string;
}

export interface DataLayer {
  id: string;
  computedProperties: ComputedPropertyWithHistory[];
  updatedAt: protobuf.timestamp | null;
}

export interface PublishDataLayerRequest {
  orgId: string;
  datalayerId: string;
}

export interface PublishedDataLayer {
  dataLayer: DataLayer | null;
  publishedAt: protobuf.timestamp | null;
}

export interface PublishDataLayerResponse {
  dataLayer: PublishedDataLayer | null;
}

export interface GetPublishedDataLayerRequest {
  orgId: string;
}

export interface GetPublishedDataLayerResponse {
  dataLayer: PublishedDataLayer | null;
}
